import React from "react";
import { StandardCase } from "@src/lms/jelly/extensions/layouts/standard-case/StandardCase";
import { Accordion, AccordionItem } from "@src/lms/jelly/extensions/ui";
import { useIntl } from "react-intl";

import { messages } from "./About.messages";
import styles from "./About.module.scss";
import { SpatialCarousel } from "../../..";
import { PhotoView } from "../../../photo-view/PhotoView";

import * as appConfig from "appConfig";
import { useUi } from "@jelly/lesson";
import { nl2br } from "@src/utils/nl2br";

const ACCORDION_IDS = {
  about: "about",
  placeholder: "placeholder",
} as const;

interface About {
  title: string;
}

export const About: React.FC<About> = ({ title }) => {
  const { formatMessage } = useIntl();
  const ui = useUi();

  let linkToPresent = "placeholder-link";
  try {
    const url = new URL(formatMessage(messages.link));
    linkToPresent = url.host;
  } catch {
    // ...
  }

  const accordion = (
    <div className={styles.accordion}>
      <ui.Scrollbars>
        <AccordionItem id={ACCORDION_IDS.about} title={formatMessage(messages.accordionItem1Title)} unmountChildrenWhenHidden>
          <p className={styles.description}>{formatMessage(messages.description)}</p>

        </AccordionItem>
        <AccordionItem
          id={ACCORDION_IDS.placeholder}
          title={formatMessage(messages.accordionItem2Title)}
          unmountChildrenWhenHidden
        >
          <p className={styles.description}>{nl2br(formatMessage(messages.accordionItem2Description))}</p>
          <div className={styles.link}>
            <ui.Button size="small" shape={"normal"} theme={"primary"} onClick={() => window.open(formatMessage(messages.link))}>
              {linkToPresent}
            </ui.Button>
          </div>
        </AccordionItem>
      </ui.Scrollbars>
    </div>
  );

  const leftComponent = (
    <Accordion allowMultiOpen={false} defaultOpen={[ACCORDION_IDS.about]}>
      {accordion}
    </Accordion>
  );

  return (
    <StandardCase title={title} leftComponent={leftComponent}>
      <div className={styles.gallery}>
        {/*// @ts-expect-error We cannot override layouts using Contexts :/*/}
        <SpatialCarousel>
          {["1.jpg", "2.jpg"].map((src, index) => (
            <PhotoView
              key={src}
              imgSrc={`${appConfig.STATIC_ASSETS_URL}/lms/case/case05/about/${src}`}
              description={formatMessage(messages[`galleryDescription${index + 1}` as keyof typeof messages])}
              imgMode={"contain"}
            />
          ))}
        </SpatialCarousel>
      </div>
    </StandardCase>
  );
};
